import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, DeferLoadingStrategy, provideConfig } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';
import { SharedModule } from 'src/app/shared/shared.module';
import { ResponsiveBannerComponent } from '../../responsive-banner/responsive-banner.component';
import { CustomerServiceBannerComponent } from './customer-service-banner.component';

@NgModule({
  imports: [CommonModule, MediaModule, SharedModule, CustomerServiceBannerComponent],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ShimanoResponsiveBannerComponent: {
          component: ResponsiveBannerComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
})
export class CustomerServiceBannerModule {}
